import jwt_decode from "jwt-decode";
import * as storageConstants from "./constants/storage";

export const getIntegrationIdFromToken = (token) => {
    const decodedJwt = jwt_decode(token);
    if (decodedJwt.companyId) {
        return decodedJwt.companyId;
    }
    const sessionCompany = getDefaultOrSessionCompany()
    return sessionCompany.integrationId;
}

export const getCompanyNameFromToken = (token) => {
    const decodedJwt = jwt_decode(token);
    if (decodedJwt.companyName) {
        return decodedJwt.companyName;
    }

    console.error(`Company name is missing for integrationId: ${decodedJwt.companyId}.`)
    return ""
}

export const getDefaultOrSessionCompany = () => {
    const company = sessionStorage.getItem(storageConstants.COMPANY);
    if (company) {
        return JSON.parse(company);
    }
    return defaultCompany;
}

const defaultCompany = {
    name: "BANCA ATOS",
    codiceFiscale: "4365421009",
    integrationId: "LA00135913",
    // parentCustomerName: "",
    piva: "4365421009",
    livelloDiAssistenza: "Base",
    livelloDiAssistenzaId: 1,
    changeInSelf: false
}
